import { render, staticRenderFns } from "./page-edit.vue?vue&type=template&id=aa1500e4&"
import script from "./page-edit.vue?vue&type=script&lang=ts&"
export * from "./page-edit.vue?vue&type=script&lang=ts&"
import style0 from "./page-edit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports